import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { mergeMap } from 'rxjs/operators';
import { AppUrls } from '../app-urls';
import { from, Observable, of } from 'rxjs';
import * as StackTrace from 'stacktrace-js';
import { ClientError } from '../../generated/common/models/client-error';
import { BusinessOperation } from '../models/business-operation';
import { ParticipantOffersUrlBuilderService } from './participant-offers-url-builder.service';

@Injectable({
  providedIn: 'root'
})
export class ServerLoggerService {
  private httpBack: HttpClient;
  constructor(
    private _http: HttpClient,
    private _urlBuilder: ParticipantOffersUrlBuilderService,
    private _location: Location,
    private _httpBackend: HttpBackend
  ) {
    this.httpBack = new HttpClient(_httpBackend);
  }
  public logBusinessOperation(params: BusinessOperation, isCustomer?: boolean) {
    const url = this._urlBuilder.getAbsoluteFksUrl(
      isCustomer
        ? AppUrls.logs.customerBusinessOperationLogUrl
        : AppUrls.logs.businessOperationLogUrl
    );
    return this.httpBack.post(url, params, {
      withCredentials: true,
    }) as Observable<any>;
  }

  public logErrorWithMessage(error: unknown, message: string): void {
    let decorated: unknown;

    if (error instanceof Error) {
      decorated = Object.assign(error, {
        message: `${message}${error.message}`
      });
    } else {
      const text = typeof error === 'string'
        ? error
        : JSON.stringify(error, null, 2);
      decorated = `${message}${text}`;
    }

    this.logError(decorated);
  }

  public logError(error: unknown): void {
    console.error(error);

    let clientError = new ClientError();
    let observable = of(clientError);

    clientError.message =
      error instanceof Error
        ? error.message
        : typeof error === 'string'
          ? error
          : JSON.stringify(error);
    clientError.location = this._location.prepareExternalUrl(this._location.path());

    if (error instanceof Error) {
      let stacktrace = from(
        StackTrace.fromError(error).then((frames) => {
          clientError.stacktrace = frames.splice(0, 20).map((f) => f.toString());

          return clientError;
        })
      );

      observable = observable.pipe(mergeMap((_) => stacktrace));
    }

    const url = this._urlBuilder.getTenderPlatformAbsoluteUrl(AppUrls.logs.errorUrl);

    observable.subscribe((err) => {
      this._http
        .post(url, err, {
          headers: { 'Content-Type': 'application/json' },
        })
        .subscribe();
    });
  }
}
